import { useWeddingWebsiteQuery } from '../generated/graphql';

// This will probably get deleted once GQL is doing this logic

const useWWSUrl = (): string => {
  const { data } = useWeddingWebsiteQuery();

  if (!data) {
    return '';
  }

  const { purchaseDomain, vanityRoot, vanityUrl, slug } = data.weddingWebsite;

  const shareUrl = vanityUrl || `us/${slug}`;

  if (purchaseDomain?.name && !purchaseDomain?.isExpired) {
    return `www.${purchaseDomain.name}`;
  } else if (vanityRoot) {
    return `${vanityRoot}${shareUrl}`;
  }

  return `${process.env.REACT_APP_HOSTNAME}${shareUrl}`;
};

export default useWWSUrl;
